<template>
	<div class="unselected tabs-list" :class="{hide: !isShowTabs}" ref="tabs_wrapper">
		<el-tabs
			v-if="isShowTabs"
			ref='tabs'
			v-model="currentMenuTab"
			type="card"
			closable
			@tab-remove="removeTab"
			@tab-click="clickTab"
		>
			<el-tab-pane v-for="(item, index) in allTabs" :key="item.name" :label="item.title" :name="item.name">
			</el-tab-pane>
		</el-tabs>
		<!--页签工具菜单-->
		<div v-if="this.allTabs.length > 1" class="tabs-contextmenu" :style="contextMenuStyle">
			<div
				v-if="contextMenu.index > 0"
				class="tabs-contextmenu-item"
				@click="removeLeftTabs(contextMenu.index)"
			>
				<div class="tabs-contextmenu-item-icon">
					<i class="el-icon-arrow-left"></i>
				</div>
				<div class="tabs-contextmenu-item-text">关闭左侧</div>
			</div>
			<div
				v-if="contextMenu.index < allTabs.length - 1"
				class="tabs-contextmenu-item"
				@click="removeRightTabs(contextMenu.index)"
			>
				<div class="tabs-contextmenu-item-icon">
					<i class="el-icon-arrow-right"></i>
				</div>
				<div class="tabs-contextmenu-item-text">关闭右侧</div>
			</div>
			<div
				class="tabs-contextmenu-item"
				@click="removeOtherTabs(contextMenu.index)"
			>
				<div class="tabs-contextmenu-item-icon">
					<i class="el-icon-close"></i>
				</div>
				<div class="tabs-contextmenu-item-text">关闭其它</div>
			</div>
		</div>
	</div>
</template>


<script>
	import { isTabbedMenu } from '@/config/menu';
  import { getMenuTabs, removeMenuTab, removeLeftTabs, removeRightTabs, removeOtherTabs } from '@/framework/utils/layout'

	export default {
		data(){
			return {
				isTabbedMenu,
				allTabs: [],
        currentMenuTab: null,
				contextMenu: {
					left: 0,
					top: 0,
					width: 106,
					visible: false,
					index: 0
				}
			}
		},
		computed: {
			isShowTabs(){
				return this.isTabbedMenu && this.allTabs.length > 0 && this.$root.siteRenderer == 'pc'
			},
			contextMenuStyle(){
				let contextMenuOptions = this.contextMenu
				return {
					left: contextMenuOptions.left + 'px',
					top: contextMenuOptions.top + 'px',
					width: contextMenuOptions.width + 'px',
					display: contextMenuOptions.visible && this.allTabs.length > 1 ? 'block' : 'none'
				}
			}
		},
		created(){
      if(this.isTabbedMenu) {
        window._dc.$on('menu-tabs-changed', (tabs, currentMenuTab)=>{
          this.allTabs = tabs;
          this.currentMenuTab = currentMenuTab ? currentMenuTab['name'] : null
        })
        window._dc.$on('menu-tabs-removed', (tabs, currentMenuTab)=>{
          this.allTabs = tabs;
          this.currentMenuTab = currentMenuTab ? currentMenuTab['name'] : null
          if(this.currentMenuTab) {
            this.$router.push({
              path: this.currentMenuTab
            })
          }
        })
      }
    },
		mounted(){
			let $tabs_wrapper = this.$refs.tabs_wrapper;
			if($tabs_wrapper) {
				$tabs_wrapper.addEventListener("contextmenu", (e)=> {
					e.preventDefault();
					e.stopPropagation()
				  if(e.target.classList.contains('el-tabs__item')){
						this.contextMenu.visible = true
						this.contextMenu.index = [].indexOf.call(
							e.target.parentNode.querySelectorAll('.el-tabs__item'),
							e.target
						)
						if(e.target.getBoundingClientRect){
							let meta = e.target.getBoundingClientRect()
							if(this.contextMenu.index){
								this.contextMenu.left = meta.left
								this.contextMenu.top = meta.top + meta.height
								this.contextMenu.width = meta.width + 1
							} else {
								this.contextMenu.left = meta.left - 1
								this.contextMenu.top = meta.top + meta.height
								this.contextMenu.width = meta.width + 2
							}
						} else {
							this.contextMenu.left = e.pageX
							this.contextMenu.top = e.pageY
							this.contextMenu.width = 106
						}

					}
				})
			}
			document.body.addEventListener('click', ()=>{
				this.contextMenu.visible = false
			})
		},
		methods: {
			removeLeftTabs,
			removeRightTabs,
			removeOtherTabs,
			removeTab(path){
        removeMenuTab(path, this.currentMenuTab)
      },
      clickTab(tab){
        this.$router.push({
          path: tab['name']
        })
      }
		}
	}
</script>
